import { RootState } from '../store'
import { notificationsMessages } from './reducer'

export const getNotifications = (state: RootState) =>
  notificationsMessages.getSelectors().selectAll(state.notifications)
